var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllTransaction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 55,
    viewBox: "0 0 65 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2815",
    "data-name": "Group 2815",
    transform: "translate(-298 -264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_937",
    "data-name": "Rectangle 937",
    width: 65,
    height: 55,
    rx: 5,
    transform: "translate(298 264)",
    fill: "rgba(21,103,254,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M79.967,66.587v5.992c0,5.992-2.4,8.389-8.389,8.389h-7.19C58.4,80.967,56,78.57,56,72.579v-7.19C56,59.4,58.4,57,64.389,57H70.38",
    transform: "translate(262.339 222.538)",
    fill: "#274371"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTransaction);
export default __webpack_public_path__ + "static/media/all-transaction.74e3c39fc9bb376a8b1b92bab12cad43.svg";
export { ForwardRef as ReactComponent };